import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import ReactPaginate from "react-paginate";
import apiConfig from "../../apiConfig";
import "./page.css";
import { useNavigate } from "react-router-dom";
import DropdownOfStatus from "./status/DropdownOfStatus";
import BackButton from "./status/BackButton";

const Dashboard = () => {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filterOrderId, setFilterOrderId] = useState("");

  const [currentPage, setCurrentPage] = useState(0);
  const [ordersPerPage] = useState(10);
  const tableRef = useRef(null);

  const fetchOrders = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${apiConfig.baseUrl}${apiConfig.ReceivedOrder}`
      );
      setOrders(response.data);
      const sortedOrders = response.data.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );
      setOrders(sortedOrders);
      setFilteredOrders(response.data);
      setLoading(false);
    } catch (err) {
      setError();
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  useEffect(() => {
    let filtered = orders;

    if (filterOrderId) {
      filtered = filtered.filter((order) =>
        order.orderID.includes(filterOrderId)
      );
    }

    setFilteredOrders(filtered);
  }, [filterOrderId, orders]);

  const handleRefresh = async () => {
    await fetchOrders();
  };



  const updateOrderStatus = async (id, newStatus, cancelDetails) => {
    setLoading(true);
    try {
      const data = {
        updateStatus: newStatus,
        cancelDetails: cancelDetails,
      };

      await axios.put(
        `${apiConfig.baseUrl}${apiConfig.OrderAcceptOrReject}/${id}`,
        data
      );

      alert(`Order ${id} status updated to ${newStatus}`);

    } catch (error) {
      alert(`Failed to update order ${id} status. Please try again.`);
    } finally {
      setLoading(false);
    }
  };

  const handleAccept = (id) => {
    updateOrderStatus(id, "Accepted", "");
  };

  const handleReject = (id) => {
    const reason = prompt("Please enter the reason for rejecting the order:");
    if (reason) {
      updateOrderStatus(id, "Not Accepted", reason);
    } else {
      alert("Reject reason is required.");
    }
  };

  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
  };

  const handleNavigate = () => {
    navigate("/admin/OrderTracking");
  };


  const offset = currentPage * ordersPerPage;
  const currentOrders = filteredOrders.slice(offset, offset + ordersPerPage);
  const pageCount = Math.ceil(filteredOrders.length / ordersPerPage);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  const buttonStyle = {
    padding: "10px 20px",
    fontSize: "16px",
    fontWeight: "bold",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    margin: "5px",
  };

  return (
    <div>
      <BackButton />
      <div className="filters">
        <label>
          Filter by Order ID:
          <input
            type="text"
            value={filterOrderId}
            onChange={(e) => setFilterOrderId(e.target.value)}
          />
        </label>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            padding: "20px",
          }}
        >
          <DropdownOfStatus />
        </div>

        <div>
          <button
            onClick={handleNavigate}
            style={{
              backgroundColor: "#007BFF",
              color: "white",
              border: "none",
              padding: "10px 20px",
              borderRadius: "5px",
              cursor: "pointer",
              transition: "background-color 0.3s",
            }}
          >
            Order Track and Update
          </button>
        </div>
        <div style={{ textAlign: "right" }}>
          <button
            onClick={handleRefresh}
            style={{
              padding: "10px 20px",
              border: "none",
              borderRadius: "5px",
              backgroundColor: "#28A745",
              color: "#fff",
              fontSize: "16px",
              cursor: "pointer",
              margin: "0 10px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
              transition: "background-color 0.3s ease",
            }}
            onMouseOver={(e) =>
              (e.currentTarget.style.backgroundColor = "#218838")
            }
            onMouseOut={(e) =>
              (e.currentTarget.style.backgroundColor = "#28A745")
            }
          >
            Refresh Data
          </button>
        </div>
      </div>
      <div ref={tableRef}>
        <h1>All Received Orders</h1>
        <table>
          <thead>
            <tr>
              <th>Items</th>

              <th>Product Price</th>
              <th>Shipping Price</th>
              <th>coupon Discount</th>

              <th>Total Amount</th>
              <th>Status</th>
              <th>Order date</th>
              <th>Order ID</th>
              <th>User ID</th>
              <th>Delivery Address</th>
              <th>Payment Status</th>
              <th>Payment Mode</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {currentOrders
              .filter((order) => order.updateStatus !== "Accepted")
              .map((order) => (
                <tr key={order._id}>
                  <td>
                    <table className="sub-table">
                      <thead>
                        <tr>
                          <th>Product ID</th>
                          <th>Product Name</th>
                          <th>Quantity</th>
                          <th> Price</th>
                        </tr>
                      </thead>
                      <tbody>
                        {order?.items.map((item) => {
                          return (
                            <tr key={item._id}>
                              <td>
                                {item?.variation?.variationId
                                  ? item?.variation?.variationId
                                  : item.productId || "N/A"}
                              </td>
                              <td>
                                {item?.variation?.variationTitle
                                  ? item?.variation?.variationTitle
                                  : item.title || "N/A"}
                              </td>
                              <td>{item.quantity}</td>
                              <td>₹{item.totalPrice}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </td>

                  {order?.items.map((item, index) => {
                    const productPrice = item.price || 0;
                    const variationPrice = item.variation?.VariationPrice || 0;

                    let totalPrice = productPrice;
                    if (item.productId && item.variation) {
                      totalPrice += variationPrice;
                    }

                    return (
                      <tr key={index}>
                        <td>₹{item.totalPrice}</td>{" "}

                      </tr>
                    );
                  })}

                  <td>₹{order.shippingCost ?? 0}</td>
                  {order?.items.map((item, index) => (
                    <tr key={index}>
                      <td>₹{item.couponDiscount}</td>
                    </tr>
                  ))}
                  <td>
                    ₹{(order.totalPrice ?? 0) + (order.shippingCost ?? 0)}
                  </td>
                  <td>{order.status}</td>
                  <td>
                    {new Date(order.createdAt).toLocaleDateString()}
                    <br />
                    {new Date(order.createdAt).toLocaleTimeString()}
                  </td>
                  <td>{order.orderID}</td>
                  <td>{order.userId}</td>
                  <td>
                    {order?.address ? (
                      <>
                        <div>Name: {order.address.name || "N/A"}</div>
                        <div>Address: {order.address.location || "N/A"}</div>
                        <div>{order.address.city || "N/A"}</div>
                        <div>{order.address.state || "N/A"}</div>
                        <div>{order.address.pincode || "N/A"}</div>
                        <div>Phone: {order.address.phone || "N/A"}</div>
                        <div>Email: {order.address.email || "N/A"}</div>
                        <div>
                          Delivery Days: {order.address.deliveryDays || "N/A"}
                        </div>
                      </>
                    ) : (
                      "Address information is not available"
                    )}
                  </td>
                  <td>{order.paymentStatus}</td>
                  <td>{order.paymentMode}</td>
                  <td>
                    <button
                      style={{
                        ...buttonStyle,
                        backgroundColor: "green",
                        opacity: loading ? 0.6 : 1,
                        cursor: loading ? "not-allowed" : "pointer",
                      }}
                      onClick={() => handleAccept(order.orderID)}
                      disabled={loading}
                    >
                      {loading ? "Loading..." : "Accept"}
                    </button>
                    <button
                      style={{
                        ...buttonStyle,
                        backgroundColor: "red",
                        opacity: loading ? 0.6 : 1,
                        cursor: loading ? "not-allowed" : "pointer",
                      }}
                      onClick={() => handleReject(order.orderID)}
                      disabled={loading}
                    >
                      {loading ? "Loading..." : "Reject"}
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      <ReactPaginate
        previousLabel={"previous"}
        nextLabel={"next"}
        breakLabel={"..."}
        pageCount={pageCount}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        onPageChange={handlePageClick}
        containerClassName={"pagination"}
        activeClassName={"active"}
      />
    </div>
  );
};

export default Dashboard;
